import * as React from 'react';
import Search from 'antd/lib/input/Search';
import { useDispatch } from 'react-redux';
import { updateUsersSearch } from '../../actions/userSearch';

const UserSearchComponent: React.FC = () => {
    const dispatch = useDispatch();

    const onSearch = (value) => {
        const query = value;
        dispatch(updateUsersSearch({ query }));
    };

    return (
        <div>
            <Search placeholder="search by name or email" allowClear onSearch={onSearch} style={{ width: 300 }} />
        </div>
    );
};

export default UserSearchComponent;
